import * as React from 'react'
import { styled } from '@mui/system'
import { TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

const StyledSearchfield = styled(TextField)(({ theme }) => ({
    '&&': {
        width: '100%',
        height: '40.5px',
        background: theme.palette.background.default,
        border: '0.7px solid #b3b3b3',
        borderRadius: '5px',
        '& .MuiInputBase-input': {
            color: theme.palette.text.primary,
            padding: '9px'

        },
        '& .MuiInputLabel-root': {
            color: theme.palette.text.primary
        }
    }
}))

const Searchfield = (props) => (
    <StyledSearchfield
        {...props}
        InputProps={{
            startAdornment: (
                <SearchIcon style={{
                    color: '#b3b3b3'
                }}
                />
            )
        }}
    />
)

export default Searchfield
